import { z } from "zod"
import { DurationSchema, TimelineSchema } from "./timing"

export const VoiceoverAudioSettingsSchema = z.object({
  volume: z.number().min(0).max(100).default(100),
  fadeInMs: z.number().default(200),
  fadeOutMs: z.number().default(200),
  duckOriginalAudio: z.boolean().default(true),
  duckLevel: z.number().min(0).max(100).default(30),
})

export const VoiceoverMediaInfoSchema = z.object({
  mediaType: z.literal("audio").default("audio"),
  originUrl: z.string(),
  previewUrl: z.string(),
  duration: z.number(),
  voiceId: z.string(),
  voiceName: z.string(),
  scriptText: z.string(),
  wordCount: z.number().default(0),
})

export const VoiceoverContentSchema = z.object({
  id: z.string(),
  voiceoverType: z.enum(["hook", "cta", "custom", "distributed"]),
  mediaInfo: VoiceoverMediaInfoSchema,
  audioSettings: VoiceoverAudioSettingsSchema.default({}),
})

export const VoiceoverSegmentSchema = z.object({
  id: z.string(),
  contentType: z.literal("Voiceover"),
  duration: DurationSchema,
  timeline: TimelineSchema,
  trimStartMs: z.number().optional().describe("Where this piece starts in its media (ms); set when a segment is split"),
  content: VoiceoverContentSchema,
})

export type VoiceoverAudioSettings = z.infer<typeof VoiceoverAudioSettingsSchema>
export type VoiceoverMediaInfo = z.infer<typeof VoiceoverMediaInfoSchema>
export type VoiceoverContent = z.infer<typeof VoiceoverContentSchema>
export type VoiceoverSegment = z.infer<typeof VoiceoverSegmentSchema>
